import { GlobalProperty } from '../../constants';
import { Helper } from '../Helper';
export class GetModulesHelper extends Helper {
    emit(sb, node, options) {
        if (options.pushValue) {
            sb.emitPushInt(node, GlobalProperty.Modules);
            sb.emitOp(node, 'PICKITEM');
        }
    }
}

//# sourceMappingURL=GetModulesHelper.js.map
